An optional field for storing additional data with a `PositionOpening`.

The metadata is not used by SEEK and won't be seen by hirers or candidates.

This field has a maximum length of 1,000 characters.
